module.exports = __webpack_public_path__ + "img/header-artwork.aeb9dabd.png";